import { render, staticRenderFns } from "./ActivityMusicListV2.vue?vue&type=template&id=6f83c1a4"
import script from "./ActivityMusicListV2.vue?vue&type=script&lang=js"
export * from "./ActivityMusicListV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports